import { Plugin, PluginKey } from "prosemirror-state";
export const emojiSuggesterMatchOffsetPluginKey = new PluginKey("emoji-suggester-match-offset");
export const emojiSuggesterMatchOffsetPlugin = () => {
    return new Plugin({
        key: emojiSuggesterMatchOffsetPluginKey,
        state: {
            init: () => ({ matchOffset: 0 }),
            apply: (tr, value) => {
                const meta = tr.getMeta(emojiSuggesterMatchOffsetPluginKey);
                if (meta) {
                    return meta;
                }
                return value;
            },
        },
    });
};
export function updateEmojiSuggesterMatchOffset(tr, matchOffset = 0) {
    return tr.setMeta(emojiSuggesterMatchOffsetPluginKey, {
        matchOffset,
    });
}
export function getEmojiSuggesterMatchOffset(state) {
    var _a;
    const pluginState = emojiSuggesterMatchOffsetPluginKey.getState(state);
    return (_a = pluginState === null || pluginState === void 0 ? void 0 : pluginState.matchOffset) !== null && _a !== void 0 ? _a : 0;
}
